import { IEmployeeAccesses } from '@entities/myTeam/model/types';
import { IAccessSettingsFormValues } from '@features/AccessSettingsForm/model/types';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

interface IUpdateEmployeeAccesses {
    accesses: IAccessSettingsFormValues;
}

export const updateEmployeeAccesses = async ({
    updatedData,
    employeeId,
}: {
    updatedData: IUpdateEmployeeAccesses;
    employeeId: number;
}) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(routable.getRoute('updateEmployeeAccesses'), {
        _employeeId_: employeeId,
    });

    try {
        const res = await $api.post<IDataResponse<IEmployeeAccesses>>(url, updatedData);

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        return error.message;
    }
};
